
import Vue from 'vue'
import AppMixin from '@/_mixins/app'
import AttachmentMixin from '@/_mixins/attachment'
import ToolbarComponent from '@/_components/bar/appToolbar/appToolbar.vue'
import CompanyAutocomplete from '@/components/Autocomplete/company.vue'
import CurrencyAutocomplete from '@/components/Autocomplete/currency.vue'
import PhoneInput from '@/_components/input/phone/phone.vue'
import RichTextField from '@/components/RichTextField/richTextField.vue'
import InvoiceRecipientCombobox from '../Components/invoiceRecipient.vue'
import { patchProject, postProject, projectSettingsFields } from '@/utils/project'
const ProjectGeneralSettings = Vue.extend({
    mixins: [AppMixin, AttachmentMixin],
    components: {
        ToolbarComponent,
        CurrencyAutocomplete,
        PhoneInput,
        CompanyAutocomplete,
        RichTextField,
        InvoiceRecipientCombobox,
    },
    props: {
        company: {
            type: Object,
            required: true,
        },
        project: {
            required: true,
        },
        initialProjectData: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        wizzard: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data() {
        return {
            loading: true,
            loadingPatch: false,
            valid: true,
            file: null as null | Record<string, any>,
            descriptionId: Date.now(),
            errors: [] as Array<any>,
            generalBase: {
                owner: { data: null },
                customId: null,
                bklrId: null,
                name: '',
                timeZone: 'Europe/Oslo',
                description: null as string | null,
                avatarFileId: null as null | string,
                address: null,
                currency: null,
                latitude: null,
                longitude: null,
                emergencyNumber: null,
                agreementUrl: null,
                itbaseUrl: null,
                customerReference: null,
                orderReference: null,
                invoiceRecipient: null,
            },
            general: {} as any,
        }
    },

    computed: {
        adminCompanies() {
            return this.$store.getters.adminCompanies
        },
        maxBytes() {
            return this.project && this.project.constraints.avatarFileId.maxBytes
                ? this.project.constraints.avatarFileId.maxBytes
                : ''
        },

        allowedExtensions() {
            return this.project && this.project.constraints.avatarFileId.allowedExtensions
                ? '.' + this.project.constraints.avatarFileId.allowedExtensions.join(',.')
                : ''
        },

        hasChanged() {
            return this.project
                ? !this.lodash.isEqual(this.project, this.general)
                : !this.lodash.isEqual(this.generalBase, this.general)
        },

        changedValues() {
            let changes = {}
            Object.keys(this.general).map((attr) => {
                if (this.project) {
                    if (!this.lodash.isEqual(this.project[attr], this.general[attr])) {
                        changes[attr] = this.general[attr] == '' ? null : this.general[attr]
                    }
                } else {
                    if (!this.lodash.isEqual(this.general[attr], this.generalBase[attr])) {
                        changes[attr] = this.general[attr] == '' ? null : this.general[attr]
                    }
                }
            })
            return changes
        },
    },

    methods: {
        initGeneralSettings() {
            this.general = this.lodash.cloneDeep(this.generalBase)
            if (!this.projectId) this.general.owner.data = this.lodash.cloneDeep(this.company)
            if (this.project) {
                Object.keys(this.general).map((attr) => {
                    this.general[attr] = this.lodash.cloneDeep(
                        this.project ? this.project[attr] : this.general[attr]
                    )
                })
            }
            Object.keys(this.initialProjectData).forEach((attr) => {
                if (this.general.hasOwnProperty(attr)) {
                    this.general[attr] = this.lodash.cloneDeep(this.initialProjectData[attr])
                }
            })
        },
        // Will be removed when new editor is implemented
        passDescription(data: string) {
            this.general.description = data
        },

        ruleBRKL() {
            return [
                () =>
                    !this.errors.includes('bklrIdUsedOnOtherProject') ||
                    this.$t(`project_errors['project.patch.bklrIdUsedOnOtherProject']`),
                () =>
                    !this.errors.includes('bklrProjectDoesNotExist') ||
                    this.$t(`project_errors['project.patch.bklrProjectDoesNotExist']`),
            ]
        },

        urlRule() {
            return (value: string) =>
                !value ||
                /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/.test(
                    value
                )
        },
        getConstraints(field: string, constraint: string) {
            return this.project && this.project.constraints[field]
                ? this.project.constraints[field][constraint]
                : true
        },
        async handleSubmit() {
            this.loading = true
            if (this.project) {
                await this.handlePatch()
            } else {
                await this.handlePost()
            }
            this.loading = false
            this.descriptionId = Date.now()
        },
        async handlePatch() {
            if (this.project) {
                const project = {
                    type: this.project.type,
                    id: this.project.id,
                    ...this.changedValues,
                }

                const res = await patchProject(
                    project,
                    'owner,modules.module',
                    projectSettingsFields
                ).catch((error) => {
                    this.$store.commit('closeSnackbar')
                    this.loading = false

                    error.data.response.data.errors.map((err) => {
                        this.errors.push(err.code)
                    })
                    this.$refs?.form?.validate()
                })

                if (res) {
                    this.$emit('update', res)
                }
            }
        },
        async handlePost() {
            const project = {
                type: 'project',
                ...this.changedValues,
            }
            const res = await postProject(
                project,
                'owner,modules.module',
                projectSettingsFields
            ).catch((error) => {
                this.$store.commit('closeSnackbar')
                this.loading = false
                error.data.response.data.errors.map((err) => {
                    this.errors.push(err.code)
                })
                this.$refs?.form?.validate()
            })

            if (res) {
                this.$emit('update', res)
            }
        },
        cancle() {
            this.initGeneralSettings()
            this.$emit('close')
            this.descriptionId = Date.now()
        },
        async uploadFile(fileObject: any) {
            this.file = {
                links: {
                    download: URL.createObjectURL(fileObject),
                },
                fileId: null,
            }

            let res = await this.postFile(fileObject).catch(() => {
                this.$store.dispatch('errorSnackbar', 'Problems with uploading the file')
            })
            if (res) {
                this.general.avatarFileId = res
                this.file.fileId = res
            }
        },
    },

    watch: {
        project: {
            immediate: true,
            handler() {
                this.loading = true
                this.initGeneralSettings()
                this.loading = false
            },
        },
        valid: {
            immediate: true,
            handler() {
                this.$emit('validate', this.valid)
            },
        },
    },
})

export default ProjectGeneralSettings
